import React from "react";
import styled from "styled-components";
import { Divider, MainTitle, device } from "../styled";
import SalonCard from "./SalonCard";

const Container = styled.div`
  text-align: center;
  background-color: #000;
  color: #fff;
  padding: 40px 0;
  h1 {
    margin-top: 0px;
  }

  ${Divider} {
    margin-bottom: 20px;
  }
`;

const SalonWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;
  gap: 30px;

  @media ${device.desktop} {
    flex-direction: row;
    justify-content: center;
  }
`;

const Salons = () => {
  return (
    <Container>
      <MainTitle>Szalonjaink</MainTitle>
      <Divider />
      <SalonWrapper>
        <SalonCard
          city={"Mosonmagyaróvár"}
          street={"Magyar utca 4"}
          openinHoursWeekdays={"H-P: 10:00 - 20:00"}
          openinHoursWeekends={"Sz-V: Zárva"}
          phoneNumber={"+36203278062"}
          reservationUrl={
            "https://www.fresha.com/a/artist-barber-shop-mosonmagyarovar-magyar-utca-4-kr8qumem"
          }
          salonImage={"/salons/moson_salon.jpg"}
          googleMapUrl={"https://maps.app.goo.gl/BoXKRsHoSV1PMzJQ8"}
        />
        <SalonCard
          city={"Győr"}
          street={"Móricz Zsigmond rkp. 8"}
          openinHoursWeekdays={"H-P: 09:00 - 19:00"}
          openinHoursWeekends={"Sz: 09:00 - 12:00"}
          phoneNumber={"+36203278062"}
          reservationUrl={
            "https://www.fresha.com/a/a-r-t-i-s-t-gyor-gyor-moricz-zsigmond-rakpart-hsqml4zk"
          }
          salonImage={"/salons/gyor_salon.jpg"}
          googleMapUrl={"https://maps.app.goo.gl/BoXKRsHoSV1PMzJQ8"}
        />
        <SalonCard
          city={"Csorna"}
          street={"Soproni út 63"}
          openinHoursWeekdays={"H, Sz, P: 09:00 - 20:00"}
          openinHoursWeekdaysOne={"K: 08:00 - 20:00"}
          openinHoursWeekdaysTwo={"Cs: 10:00 - 20:00"}
          openinHoursWeekends={"Sz-V: Zárva"}
          phoneNumber={"+36203278062"}
          reservationUrl={
            "https://www.fresha.com/a/kecso-hair-barber-shop-csorna-soproni-ut-63-esv2xp2x"
          }
          salonImage={"/salons/csorna_salon.jpg"}
          googleMapUrl={"https://maps.app.goo.gl/81d36KBCctfrpnPGA"}
        />
      </SalonWrapper>
    </Container>
  );
};

export default Salons;
